import React, { useState, useEffect } from "react";
import { apiGet } from "../../services/api";

interface ChartDrugItem {
  id: number | string;
  name: string;
  stock_qty: number;
}

export default function StockChartPanel() {
  const [chartData, setChartData] = useState<ChartDrugItem[]>([]);

  useEffect(() => {
    const loadChartData = async () => {
      try {
        const data = await apiGet("/api/pharmacy/chart/data");
        setChartData(Array.isArray(data) ? (data as ChartDrugItem[]) : []);
      } catch (e) {
        console.error("Failed to load chart data", e);
        setChartData([]);
      }
    };
    loadChartData();
    const interval = setInterval(loadChartData, 30000);
    return () => clearInterval(interval);
  }, []);

  if (chartData.length === 0) {
    return (
      <div className="mod-card" style={{ display: 'flex', flexDirection: 'column', height: '100%', padding: '24px' }}>
        <div style={{ paddingBottom: '16px', borderBottom: '1px solid #e2e8f0', marginBottom: '20px' }}>
          <h4 style={{ margin: 0, color: '#0f172a', fontSize: '1.2rem', display: 'flex', alignItems: 'center', gap: '8px' }}>📊 Stock Chart</h4>
        </div>
        <div className="mod-empty-state" style={{ flex: 1, margin: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px dashed #cbd5e1' }}>
          No drugs selected for chart. Check "Show in Bar Chart" in stock entry.
        </div>
      </div>
    );
  }

  const maxStock = Math.max(...chartData.map((d) => d.stock_qty), 1);

  return (
    <div className="mod-card" style={{ display: 'flex', flexDirection: 'column', height: '100%', padding: '24px' }}>
      <div style={{ paddingBottom: '16px', borderBottom: '1px solid #e2e8f0', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 style={{ margin: 0, color: '#0f172a', fontSize: '1.2rem', display: 'flex', alignItems: 'center', gap: '8px' }}>📊 Stock Chart (Units vs Drug)</h4>
        <span style={{ fontSize: '0.85rem', fontWeight: 600, color: '#3b82f6', background: '#eff6ff', padding: '4px 12px', borderRadius: '12px' }}>{chartData.length} drugs</span>
      </div>
      <div style={{ flex: 1, overflowY: 'auto' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {chartData.map((drug) => {
            const percentage = (drug.stock_qty / maxStock) * 100;
            return (
              <div key={drug.id} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div style={{ fontSize: '0.9rem', fontWeight: 500, color: '#475569', display: 'flex', justifyContent: 'space-between' }}>
                  <span>{drug.name}</span>
                  <span style={{ fontWeight: 700, color: '#0f172a' }}>{drug.stock_qty}</span>
                </div>
                <div style={{ height: '8px', background: '#f1f5f9', borderRadius: '4px', overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: `${percentage}%`, background: 'linear-gradient(90deg, #3b82f6, #60a5fa)', borderRadius: '4px', transition: 'width 0.5s ease' }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
